import React, { useState, useEffect  } from "react";
import { Form, Input,Select,message,  Row, Col, TimePicker,InputNumber ,Button,notification}from "antd";
import { SaveOutlined,CloseCircleFilled,DeleteOutlined,HighlightOutlined} from "@ant-design/icons";
import {MapContainer, useMapEvent,TileLayer,Marker,Popup} from "react-leaflet";
// import { OpenStreetMapProvider } from "react-leaflet-geosearch";
// import SearchControl from "./SearchControl";
import { OpenStreetMapProvider } from "leaflet-geosearch";
import SearchField from "./SearchControl";
import L from "leaflet";

import { get} from "../../../api/get";
import { getAccessTokenApi } from "../../../api/auth";


import "./MapAddOrders.scss";
import "leaflet/dist/leaflet.css";

export default function MapAddOrders(props) {
  // const prov = OpenStreetMapProvider();
  const {nombre,isInput}=props;
  const [puntos, setpuntos] = useState([]);
  const [Data, setData] = useState([]);
  const [hubs, sethubs] = useState([]);
  const [puntosNuevos, setpuntosNuevos] = useState([]);
  const [nuevos_, setnuevos_] = useState([]);
  const [isAllowed, setisAllowed] = useState(false);
  const [circular, setCircular] = useState(false);
  const [auxiliar, setauxiliar] = useState(false);
  const [num, setnum] = useState(0);
  const [inputs, setInputs] = useState({
    order_name: "",
    order_earlytime: "",
    order_latetime: "",
    order_servicetime: 0,
    order_weight: 0.00,
    order_items: 0,
    order_hub: 0,
    order_pc: "",
    order_mode: "",
  });
  const { Option } = Select;
  var punto = [];
  const format = 'HH:mm';
  var nuevos=nuevos_
  var numDeleted=0

  useEffect( () =>  { 
    const token = getAccessTokenApi();
    var DATA ;
    // console.log(nombre)
    const id_excel = nombre.replace('.xlsx',''); 
    get('getExcelRawInput','getExcelRawInput',`/${id_excel}` ).then((response) => {
    // getExcelFromIDInput(token, id_excel).then((response) => {
      DATA = response.DATA;
      setData(DATA.IN1_Orders)
      // console.log('Data: ',DATA);
      // console.log(puntosNuevos)

      var puntos2 = [];
      var hubs2 = [];
      DATA.IN2_Hubs.map(function (x, index) {
        hubs2.push(
          <Option value={index}>{x.hub_name}</Option>
        );
      })

      DATA.IN1_Orders.map(function (x) {
        if(x.order_mode==='shipment'){
          puntos2.push({
            order_id:x.order_id+'s',
            punto1: [parseFloat(x.order_lat1), parseFloat(x.order_lon1)],
          });
          puntos2.push({
            order_id:x.order_id+'f',
            punto1: [parseFloat(x.order_lat2), parseFloat(x.order_lon2)],
          });
        }else{
          puntos2.push({
            order_id:x.order_id,
            punto1: [parseFloat(x.order_lat1), parseFloat(x.order_lon1)],
          });}

      }); 
      sethubs(hubs2);
      for (let i = 0; i < puntos2.length; i++) {
       
          punto.push(
            <Marker 
            icon={L.divIcon({
           
              html: `<div class="marker-capillar">
                 <div class="green-circle" >
                 </div>
                 <div class="number" >
                 ${puntos2[i].order_id}
                 </div>
               </div>`,
            })}
            position={puntos2[i].punto1}>
              <Popup className="popUpMarcador" closeButton={true}>
             <div className="popUpMarcador-top">
               ID: {puntos2[i].order_id}
              </div>
              
              </Popup>
            </Marker>
          );
       
      }
      setpuntos(punto);
      
      var auxi=nuevos_
      for (let i = nuevos_.length; i < num; i++) {
        auxi.push({
          order_name: "",
          order_earlytime: "",
          order_latetime: "",
          order_servicetime: 0,
          order_weight: 0.00,
          order_items: 0,
          order_hub: 0,
          order_pc: "",
          order_mode: "",
          isSaved:0}
          )
        }
        setnuevos_(auxi);
        // console.log(auxi,'jeje')
        // console.log(puntosNuevos,'jeje')
    })
    
  }, [auxiliar]);



  const finish = async (e) => {
      // console.log('hola: ',inputs)
      const order_name = nuevos[num].order_name
      const order_earlytime = nuevos[num].order_earlytime
      const order_latetime = nuevos[num].order_latetime
      const order_weight = nuevos[num].order_weight
      const order_items = nuevos[num].order_items
      const order_pc = nuevos[num].order_pc
      const order_mode = nuevos[num].order_mode
      console.log(nuevos[num]) 
      console.log(nuevos) 
    
    
    if (order_name=== "" ||
    order_earlytime=== "" ||
    order_latetime=== "" ||
    order_weight=== 0.00 ||
    order_items=== 0 ||
    order_pc=== "" ||
    order_mode=== "") {
      // notification["error"]({
      //   message: "All fields are compulsory",
      // });
      message.error(`All fields are compulsory`);
    } else {
      nuevos[num].isSaved= 1
      message.error(`Point data saved`);
      // notification["success"]({
      //   message: "Point data saved",
      // });
      // resetForm(); //Reseteo el usuario
    }
  }

  const deletes = async (e) => {
    console.log(num,'numero',e)
    // nuevos[num].order_name= ""
    // nuevos[num].order_earlytime= ""
    // nuevos[num].order_latetime= ""
    // nuevos[num].order_servicetime= 0
    // nuevos[num].order_weight= 0.00
    // nuevos[num].order_items= 0
    // nuevos[num].order_hub= 0
    // nuevos[num].order_pc= ""
    // nuevos[num].order_mode= ""
    console.log('deletePre: ',nuevos,)
    nuevos.splice(num-numDeleted,1)
    console.log('deletePost: ',nuevos)
    recargarVisualizacionPuntos(nuevos,num)
    
  }
  
  function recargarVisualizacionPuntos(nuevos,num){
    //TODO: REVISAR ESTA FUNCION
    let puntosN=puntosNuevos;
    puntosN.splice(num,1)
    let puntos_=nuevos_;
    puntos_.splice(num,1)
    // let longitudInit=puntosNuevos.length;
    // let numPrima=num
    // puntosN.slice(0,num)
    // for (let i = numPrima; i <longitudInit; i++) {
    //   puntosN.push(<Marker 
    //     icon={L.divIcon({
      
    //       html: `<div class="marker-capillar">
    //         <div class="red-circle" >
    //         </div>
    //         <div class="number" >
    //             ${numPrima}
    //         </div>
    //       </div>`,
    //     })}
    //     position={puntosNuevos[numPrima]['props'].position}>
    //       <Popup className="popUpMarcador" closeButton={true}>
    //       &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
           
    //         <div className="popUpMarcador-top">
    //           <div className="popUpMarcador-in">
    //           <Form className="form-add" onChange={changeForm}>
    //           <Form.Item>
    //                   <Input
    //                     placeholder="Order name..."
    //                     name='order_name'
    //                     />
    //                 </Form.Item>
    //             <Row gutter={24}>
    //               <Col span={12}>
    //                 <Form.Item>
    //                   <TimePicker 
    //                   name='order_earlytime1'
    //                   placeholder="Early Time"
    //                   format={format} 
    //                   onChange={(time)=>{
    //                     // console.log(num)
    //                     nuevos[num].order_earlytime=time.format('HH:mm')
    //                     // console.log(time.format('HH:mm'))
    //                     }}/>
    //                 </Form.Item>
    //               </Col>
    //               <Col span={12}>
    //                 <Form.Item>
    //                   <TimePicker 
    //                   name='order_latetime1'
    //                   placeholder="Late Time"
    //                   format={format} 
    //                   onChange={(time)=>{
    //                     nuevos[num].order_latetime=time.format('HH:mm')
    //                     // console.log(time.format('HH:mm'))
    //                     }}/>
    //                 </Form.Item>
    //               </Col>
    //             </Row>

    //             <Row gutter={24}>
    //               <Col span={12}>
    //                 <Form.Item>
    //                   <InputNumber
    //                   name='order_servicetime1'
    //                   addonBefore='Service Time'
    //                   min={0}
    //                   max={99}
    //                   step={1}
    //                   style={{
    //                     margin: '0px 0px 0px 0px',
    //                   }}
    //                   defaultValue={0} 
    //                   onChange={onChangeST}
    //                   />
    //                 </Form.Item>
    //               </Col>
    //               <Col span={12}>
    //                 <Form.Item>
    //                   <Select
    //                     placeholder="Select a Hub"
    //                     name='order_idhub'
    //                     onChange={(value)=>{
    //                       nuevos[num].order_idhub=value
    //                       // console.log(value)
    //                     }}
    //                     >
    //                     {hubs}
    //                   </Select>
    //                 </Form.Item>
    //               </Col>
    //             </Row>

    //             <Row gutter={24}>
    //               <Col span={12}>
    //                 <Form.Item>
    //                   <Input
    //                     placeholder="CP"
    //                     name='order_pc'
    //                   />
    //                 </Form.Item>
    //               </Col>
    //               <Col span={12}>
    //                 <Form.Item>
    //                   <Select
    //                     placeholder="Select type"
    //                     name='order_mode'
    //                     onChange={(value)=>{
    //                       nuevos[num].order_mode=value
    //                       // console.log(value)
    //                     }}
    //                   >
    //                     <Option value="pickup">pickup</Option>
    //                     <Option value="delivery">delivery</Option>
    //                   </Select>
    //                 </Form.Item>
    //               </Col>
    //             </Row>

    //             <Row gutter={24}>
    //               <Col span={12}>
    //                 <Form.Item>
    //                   <InputNumber
    //                   addonBefore='Items'
    //                   name='order_items'
    //                     min={0}
    //                     max={9999999}
    //                     step={1}
    //                     style={{
    //                       margin: '0px 0px 0px 0px',
    //                     }}
    //                     defaultValue={0} 
    //                     onChange={onChangeIT}
    //                   />
    //                 </Form.Item>
    //               </Col>
    //               <Col span={12}>
    //                 <Form.Item>
    //                    <InputNumber
    //                   addonBefore='Weight'
    //                   name='order_weight'
    //                     min={0}
    //                     max={9999999}
    //                     step={0.01}
    //                     style={{
    //                       margin: '0px 0px 0px 0px',
    //                     }}
    //                     defaultValue={0} 
    //                     onChange={onChangeWE}
    //                   />
    //                 </Form.Item>
    //               </Col>
    //             </Row>

    //             <div  style={{display:'flex',justifyContent:'space-around'}}>
    //               <Col justify='space-around'>
    //                 <Form.Item>
    //                   <Button type="submit" htmlType="submit" className="btn-submit" onClick={finish}>
    //                     Save Point Data
    //                   </Button>
    //                 </Form.Item>
    //               </Col>
    //               <Col justify='space-around'>
    //                 <Form.Item>
    //                   <Button type="danger" htmlType="submit" className="btn-submit" onClick={deletes}>
    //                     Delete order
    //                   </Button>
    //                 </Form.Item>
    //               </Col>
    //             </div>
               
    //           </Form>
    //             </div>
    //         </div>
          
    //       </Popup>
    //     </Marker>)
    //   numPrima=numPrima+1;

    // }
    
    // setpuntosNuevos(puntosN)
    // setauxiliar(!auxiliar)
    // setnum(numPrima)
    setpuntosNuevos(puntosN)
    setnuevos_(puntos_)
    setauxiliar(!auxiliar)
    numDeleted=numDeleted+1
    // console.log(numDeleted,puntosNuevos,nuevos_)
  }

  const onChangeST = (value) => {
    nuevos[num].order_servicetime=value
  };
    
  const onChangeIT = (value) => {
    nuevos[num].order_items=value
  };
      
  const onChangeWE = (value) => {
    nuevos[num].order_weight=value
  };
      
  const changeForm = (e) => {
    nuevos[num][e.target.name]=e.target.value
  };

  async function  simularPuntos(vector){
    var faltan=''
    var j=0
    var auxil=puntos
    var auxilNuevos=puntosNuevos
    var falta=0
    var numeracion= Data.length;
    for (let i = 0; i < nuevos.length; i++) {
      if(nuevos[i].isSaved===0){
        // console.log('falta el ',i)
        faltan=faltan+`${i}, `
        falta=1
      }
    }

    if(falta===0){
      for (let i = 0; i < nuevos.length; i++) {
        auxil.push(
          <Marker 
          icon={L.divIcon({
          
            html: `<div class="marker-capillar">
                <div class="green-circle" >
                </div>
                <div class="number" >
                    ${numeracion+j}
                </div>
              </div>`,
          })} 
          position={puntosNuevos[0]['props'].position}>
            <Popup className="popUpMarcador" closeButton={true}>
            <div className="popUpMarcador-top">
              Punto {puntos.length+j}: {puntosNuevos[0]['props'].position} 
            </div>
            
            </Popup>
          </Marker>
        );
        j=j+1
        // console.log('ahi va: ',auxilNuevos)
        auxilNuevos.splice(0,1)
        // console.log('resp: ',auxilNuevos)
      }

      // console.log(nuevos_,'jeje')
      // console.log(auxil,' viejos')
      // console.log(auxilNuevos,' nuevos')
      setnuevos_([]);
      setpuntos(auxil);
      setnum(0)
      // setauxiliar(!auxiliar)
      //setpuntosNuevos(auxilNuevos);
    }
    // const map = useMapEvent('click', (e) => {})
    var guardar=false
    if(faltan.length<=1){
      guardar=true
      
    }else{
      notification["success"]({
        message: `Complete points ${faltan} to save changes, or delete them.`,
      });
      // message.success(`Complete points ${faltan} to save changes, or delete them.`);
      // message.error(`Complete points ${faltan} to save changes, or delete them.`);
    }
    
    // if(guardar){
      
    //   var status;
    //   var urlFetch='';
    //   var messag=''; 
    //   //TODO: HACER FUNCION EN EL BACK
    //   var url= `${basePath}/${apiVersion}/simulate-all-points`;
  
    //   var datos = {
    //     vector:vector,
    //     name:nombre
    //   }
  
    //   const params = {
    //     method: "POST",
    //     headers: {
    //       "Content-Type": "application/json",
    //        Authorization: "Bearer " + getAccessTokenApi(),
    //       refreshToken: "Bearer " + getRefreshTokenApi(),
    //       functionname:'addPoints',
    //       ippublica:getPublicIP()
    //     },
    //     body: JSON.stringify(datos),
    //   };
  
    //   return await fetch(url, params)
    //   .then((response) => {
    //     status=response.status;
    //     urlFetch=response.url;
    //     urlFetch=urlFetch.replace(`https://capillarit.eu:3004/`,'')
    //     return response.json();
    //   })
    //   .then((result) => {
    //     if(status!==200){
    //       messag=result.message
    //       notification["error"]({
    //         message: `Error ${status} in function: ${urlFetch}`,
    //         description:messag
    //       });
    //       getContarError(urlFetch,messag);
    //     }else{
    //       notification["success"]({
    //         message: `Changes saved!`,
    //         description:'Click "next" to continue.'
    //       });
    //     }
    //     return result;
    //   })
    //   .catch((err) => {
    //     return err.message;
    //   });
    //   guardar=false
    // }
  }

 
  function MovingMarker() {
    const map = useMapEvent('click', (e) => {
    //  console.log("click",e.latlng.lat)
    //  console.log("click",e.latlng.lng)
    //  console.log("puntosN",puntosNuevos)
      var puntosN=puntosNuevos;
      

      puntosN.push(
          <Marker 
          icon={L.divIcon({
        
            html: `<div class="marker-capillar">
              <div class="red-circle" >
              </div>
              <div class="number" >
                  ${num}
              </div>
            </div>`,
          })}
          position={[e.latlng.lat, e.latlng.lng]}>
            <Popup className="popUpMarcador" closeButton={true}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
             
              <div className="popUpMarcador-top">
                <div className="popUpMarcador-in">
                <Form className="form-add" onChange={changeForm}>
                    {/* <Form.Item>
                        <Input
                          placeholder="Order name..."
                          name='order_name'
                          />
                      </Form.Item> */}
                  <Row gutter={24}>
                    <Col span={12}>
                    <Form.Item>
                        <InputNumber
                        name='order_longitude'
                        addonBefore='Longitud'
                        min={e.latlng.lng.toFixed(6)}
                        max={e.latlng.lng.toFixed(6)}
                        style={{
                          margin: '0px 0px 0px 0px',
                        }}
                        defaultValue={e.latlng.lng.toFixed(6)} 
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                    <Form.Item>
                        <InputNumber
                        name='order_latitude'
                        addonBefore='Latitud'
                        min={e.latlng.lat.toFixed(6)}
                        max={e.latlng.lat.toFixed(6)}
                        style={{
                          margin: '0px 0px 0px 0px',
                        }}
                        defaultValue={e.latlng.lat.toFixed(6)} 
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  {/* <Row gutter={24}>
                    <Col span={12}>
                      <Form.Item>
                        <TimePicker 
                        name='order_earlytime1'
                        placeholder="Early Time"
                        format={format} 
                        onChange={(time)=>{
                          // console.log(num)
                          nuevos[num].order_earlytime=time.format('HH:mm')
                          // console.log(time.format('HH:mm'))
                          }}/>
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item>
                        <TimePicker 
                        name='order_latetime1'
                        placeholder="Late Time"
                        format={format} 
                        onChange={(time)=>{
                          nuevos[num].order_latetime=time.format('HH:mm')
                          // console.log(time.format('HH:mm'))
                          }}/>
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={24}>
                    <Col span={12}>
                      <Form.Item>
                        <InputNumber
                        name='order_servicetime1'
                        addonBefore='Service Time'
                        min={0}
                        max={99}
                        step={1}
                        style={{
                          margin: '0px 0px 0px 0px',
                        }}
                        defaultValue={0} 
                        onChange={onChangeST}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item>
                        <Select
                          placeholder="Select a Hub"
                          name='order_idhub'
                          onChange={(value)=>{
                            nuevos[num].order_idhub=value
                            // console.log(value)
                          }}
                          >
                          {hubs}
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={24}>
                    <Col span={12}>
                      <Form.Item>
                        <Input
                          placeholder="CP"
                          name='order_pc'
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item>
                        <Select
                          placeholder="Select type"
                          name='order_mode'
                          onChange={(value)=>{
                            nuevos[num].order_mode=value
                            // console.log(value)
                          }}
                        >
                          <Option value="pickup">pickup</Option>
                          <Option value="delivery">delivery</Option>
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={24}>
                    <Col span={12}>
                      <Form.Item>
                        <InputNumber
                        addonBefore='Items'
                        name='order_items'
                          min={0}
                          max={9999999}
                          step={1}
                          style={{
                            margin: '0px 0px 0px 0px',
                          }}
                          defaultValue={0} 
                          onChange={onChangeIT}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item>
                         <InputNumber
                        addonBefore='Weight'
                        name='order_weight'
                          min={0}
                          max={9999999}
                          step={0.01}
                          style={{
                            margin: '0px 0px 0px 0px',
                          }}
                          defaultValue={0} 
                          onChange={onChangeWE}
                        />
                      </Form.Item>
                    </Col>
                  </Row> */}

                  {/* <div  style={{display:'flex',justifyContent:'space-around'}}>
                    <Col justify='space-around'>
                      <Form.Item>
                        <Button type="submit" htmlType="submit" className="btn-submit" onClick={finish}>
                          Save Point Data
                        </Button>
                      </Form.Item>
                    </Col>
                    <Col justify='space-around'>
                      <Form.Item>
                        <Button type="danger" htmlType="submit" className="btn-submit" onClick={deletes}>
                          Delete order
                        </Button>
                      </Form.Item>
                    </Col>
                  </div> */}
                 
                </Form>
                  </div>
              </div>
            
            </Popup>
          </Marker>
      );
      
      setpuntosNuevos(puntosN)
      setauxiliar(!auxiliar)
      setnum(num+1)
    })

    return null
  }
  const prov = new OpenStreetMapProvider();
  const [markers, setMarkers] = useState([]);

  const handleAddMarker = (marker) => {
    // alert("It works");
    let tmp = markers;
    tmp.push(marker);
    setMarkers(tmp);
    console.log(markers);
  };
  // console.log(puntos[0])
  // console.log(puntos[0].props.position,'ahi va')
  return (
    (puntos.length>1)
    ?<>
     
      <div className="mapaColumn">
        <MapContainer
          className="leaflet-container"
          center={puntos[0].props.position}
          zoom={12}
          key={puntosNuevos.length || puntos.length}
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
        <SearchField
          provider={prov}
          showMarker={true}
          showPopup={false}
          popupFormat={({ query, result }) => `${result.label}.  Longitud: ${result.raw.lon}  Latitud: ${result.raw.lat}`}
          // popupFormat={({ query, result }) => result.label}
          retainZoomLevel={false}
          animateZoom={true}
          autoClose={true}
          searchLabel={"Enter address, please..."}
          keepResult={true}
          addMarker={handleAddMarker}
          maxMarkers={3}
        />
         
        {(isAllowed)&&<MovingMarker />} 
        
           
           {puntos} 
           {puntosNuevos.length > 0  && (puntosNuevos)} 
        </MapContainer>
        {/* <div style={{ border: "10px solid black" }} ref={pluginRef} /> */}
        <div className="botones-mapa">
       
          <Button className="boton"
            type="primary"
            style={{borderColor: "rgb(35,148,212)", 
                borderWidth:'2px',
                fontFamily:'report',
                color:'rgb(0,104,178)',
                fontSize:'18px',
                backgroundColor: "white" }}
            onClick={() => {
              setisAllowed(!isAllowed)}}>
              {(isAllowed)
              ?<CloseCircleFilled />
              :<HighlightOutlined />
              }
             { (isAllowed)
              ?'Disable new points'
              :'Add new points'}
              {/* ?'Disable new order points'
              :'Add new order points'} */}
          </Button>
          <Button className="boton"
            type="primary"
            style={(isAllowed)
              ?{borderColor: "rgb(35,148,212)", 
                borderWidth:'2px',
                fontFamily:'report',
                color:'rgb(0,104,178)',
                fontSize:'18px',
                backgroundColor: "white" }
              :{
                backgroundColor:'rgb(220,220,220)',
                borderWidth:'2px',
                fontSize:'15px',
                borderColor:'#737373',
                fontFamily: 'report-bold'
              }}
            disabled={(isAllowed)?false:true}
            onClick={() => {
              setnum(0)
              setpuntosNuevos([])
              numDeleted=0
              setnuevos_([])
            }}>
              <DeleteOutlined />
            Delete new points
            
          </Button>
          {/* <Button className="boton"
           style={{borderColor: "rgb(35,148,212)", 
           borderWidth:'2px',
           fontFamily:'report',
           color:'rgb(0,104,178)',
           fontSize:'18px',
           backgroundColor: "white" }}
            type="primary"
            onClick={async () => {
              // setCircular(true)
              await simularPuntos()
              // setCircular(false)
              if(isInput==true){
                window.location.href = "/admin/graphINPUTS?id="+nombre;
              }
            }}
              >
            Save Changes
            
            <SaveOutlined />
          </Button> */}
        </div>
        {
        (circular)
        ?<div style={{display:'flex',justifyContent:'center'}}>
            <div>
            </div>
            <div className="cargandos">
            </div>
            <div>
            </div>
          </div>
        :<div className="vacio">
          </div>
        }
        
      </div>
    </>
    :<div className="cargand">
      <h2>Loading ...</h2>
      <div className="cargando">
      
    </div>
    </div>
  );
}

                
       